import { useQuery } from "@tanstack/react-query";
import { getProjectMembers } from "@/app/actions/project-member/action";
import { ProjectMemberData } from "@/app/types/project/ProjectMember";
import { QueryKey } from "@/app/vars/QueryKeys";

type Options = {
  projectId?: number;
  enabled?: boolean;
  initialData?: ProjectMemberData[];
};

export function useFetchProjectMembers(options: Options = {}) {
  const { projectId, enabled = true, initialData } = options;

  return useQuery({
    queryKey: [QueryKey.PROJECT_MEMBERS, projectId],
    queryFn: () => getProjectMembers(projectId!),
    enabled: enabled && !!projectId,
    staleTime: Infinity,
    initialData,
  });
}
